import { numericFormatter } from "react-number-format";
import { Checkbox } from '@mui/material';
import { columns } from "../../../../dtos/columns";
import { RegistroVisacionDto } from "../models/respuestaRegistroVisacionDto";
import React from "react";

interface IProps {
  controlTabla: any;
  visados: any[];
  setVisados: React.Dispatch<React.SetStateAction<any[]>>;
  idsToLayout: number[];
  setIdsToLayout: React.Dispatch<React.SetStateAction<number[]>>;
}

export function useColumnResumenVisados({
  controlTabla,
  visados,
  setVisados,
  idsToLayout,
  setIdsToLayout,
}: IProps) {
  const COLUMNS: columns<RegistroVisacionDto>[] = [
    {
      name: (
        <Checkbox
          size="small"
          checked={
            controlTabla?.data?.length > 0 &&
            idsToLayout.length === controlTabla.data.length
          }
          indeterminate={
            idsToLayout.length > 0 &&
            idsToLayout.length < (controlTabla?.data?.length ?? 0)
          }
          onChange={e => {
            if (e.target.checked && controlTabla?.data) {
              setIdsToLayout(controlTabla.data.map((item: RegistroVisacionDto) => item.id));
            } else {
              setIdsToLayout([]);
            }
          }}
        />
      ),
      selector: (row: RegistroVisacionDto) => row.id,
      cell: (row: RegistroVisacionDto) => (
        <Checkbox
          size="small"
          checked={idsToLayout.includes(row.id)}
          onChange={e => {
            setIdsToLayout(prev =>
              e.target.checked
                ? [...prev, row.id]
                : prev.filter(id => id !== row.id)
            );
          }}
        />
      ),
      allowOverflow: true,
      button: true,
      export: false,
      width: '60px',
    },
    {
      name: "Id",
      selector: (row: RegistroVisacionDto) => row.id,
      sortable: true,
      sortField: "id",
      wrap: true,
      export: true,
    },
    {
      name: "Mínima fecha contable",
      selector: (row: RegistroVisacionDto) => {
        const fecha = new Date(row.fecMinContable!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fecMinContable",
      wrap: true,
      export: true,
    },
    {
      name: "Máxima fecha contable",
      selector: (row: RegistroVisacionDto) => {
        const fecha = new Date(row.fecMaxContable!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fecMaxContable",
      wrap: true,
      export: true,
    },
    {
      name: "Débitos",
      selector: (row: RegistroVisacionDto) => `$${row.debe}` || '',
      cell: (row) => numericFormatter((row.debe ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "debe",
      wrap: true,
      export: true,
    },
    {
      name: "Créditos",
      selector: (row: RegistroVisacionDto) => `$${row.haber}` || '',
      cell: (row) => numericFormatter((row.haber ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "haber",
      wrap: true,
      export: true,
    },
    {
      name: "Usuario validador",
      selector: (row: RegistroVisacionDto) => row.usuario || '',
      sortable: true,
      sortField: "usuario",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha VºBº",
      selector: (row: RegistroVisacionDto) => {
        const fecha = new Date(row.fechaVisacion!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaVisacion",
      wrap: true,
      export: true,
    },
    {
      name: "Cantidad asientos",
      selector: (row: RegistroVisacionDto) => row.cantidadAsientos || '',
      sortable: true,
      sortField: "cantidadAsientos",
      wrap: true,
      export: true,
    },
  ];

  return { COLUMNS };
}
